import { callService, loadWebtexte } from "@phoenixreisen/gateway";
import { getStartInDays } from "../../../../shared/functions/booking";
import Config from "../../../../config";
import DT from "date-and-time";
export const TIMEPATTERN = Config.date.patterns.time;
export const DAYS_WHILE_SPA_IS_BOOKABLE = -27;
export const Model = {
    loaded: false,
    webtexte: null,
    piker: null,
};
export function hasSPA(booking) {
    const travs = booking["buchung/reiseteilnehmer"] ?? [];
    for (const trav of travs) {
        const cruises = trav?.["reiseteilnehmer/kreuzfahrten"] ?? [];
        const ship = cruises[0]?.["kreuzfahrt/schiff"] ?? null;
        const provider = ship?.["schiff/dienstleister"] ?? null;
        if (provider) {
            return true;
        }
    }
    return false;
}
export function spaIsBookable(booking, dayDeltaFromNow = DAYS_WHILE_SPA_IS_BOOKABLE) {
    const today = new Date();
    const travs = booking["buchung/reiseteilnehmer"] ?? [];
    for (const trav of travs) {
        const cruises = trav?.["reiseteilnehmer/kreuzfahrten"] ?? [];
        for (const cruise of cruises) {
            const ship = cruise["kreuzfahrt/schiff"] || null;
            const hasSpa = ship && ship["schiff/dienstleister"]
                ? ship["schiff/dienstleister"].length > 0
                : false;
            const boardingAsString = cruise["kreuzfahrt/einschiffung"];
            const boardingDate = DT.parse(boardingAsString, "DD.MM.YYYY");
            if (hasSpa && today >= DT.addDays(boardingDate, dayDeltaFromNow)) {
                return true;
            }
        }
    }
    return false;
}
export function getCruises(trav) {
    const cruises = trav?.["reiseteilnehmer/kreuzfahrten"] ?? [];
    return cruises;
}
export function bookingPeriodIsOver(booking) {
    return spaIsBookable(booking, 0);
}
export function getCategories(cruise) {
    const serviceCategories = [];
    const ship = cruise?.["kreuzfahrt/schiff"] ?? null;
    const providers = ship?.["schiff/dienstleister"] ?? [];
    providers.forEach((provider) => {
        serviceCategories.push(...provider["dienstleister/angebot"]);
    });
    return serviceCategories;
}
export function getServices(category) {
    const services = category?.["kategorie/dienstleistungen"] ?? [];
    return services;
}
export function getProviderByService(cruise, service) {
    const ship = cruise?.["kreuzfahrt/schiff"] ?? null;
    const providers = ship?.["schiff/dienstleister"] ?? [];
    if (providers.length === 1) {
        return providers[0];
    }
    if (service) {
        for (const provider of providers) {
            const categories = provider?.["dienstleister/angebot"] ?? [];
            for (const cat of categories) {
                const services = cat?.["kategorie/dienstleistungen"] ?? [];
                for (const current of services) {
                    if (current?.["dienstleistung/id"] === service["dienstleistung/id"]) {
                        return provider;
                    }
                }
            }
        }
    }
    return null;
}
export function getServiceDates(cruise) {
    const pattern = Config.date.patterns.de;
    const end = DT.addDays(DT.parse(cruise["kreuzfahrt/ausschiffung"], pattern), -1);
    const start = DT.addDays(DT.parse(cruise["kreuzfahrt/einschiffung"], pattern), 1);
    return [start, end];
}
export function getServiceDatesAsStrings(cruise, pattern = "YYYY-MM-DD") {
    const times = getServiceDates(cruise);
    return [DT.format(times[0], pattern), DT.format(times[1], pattern)];
}
export function getServiceDatesAsString(cruise) {
    const pattern = Config.date.patterns.de;
    const times = getServiceDates(cruise);
    const start = DT.format(times[0], pattern);
    const end = DT.format(times[1], pattern);
    return `${start} - ${end}`;
}
export function getOpeningTime(cruise, service) {
    const provider = getProviderByService(cruise, service);
    if (provider?.["dienstleister/oeffnungszeit"]?.length > 0) {
        const start = DT.parse(provider["dienstleister/oeffnungszeit"][0], TIMEPATTERN);
        const end = DT.parse(provider["dienstleister/oeffnungszeit"][1], TIMEPATTERN);
        return [start, end];
    }
    return null;
}
export function getOpeningTimeAsString(cruise, service) {
    const times = getOpeningTime(cruise, service);
    if (times) {
        const start = DT.format(times[0], TIMEPATTERN);
        const end = DT.format(times[1], TIMEPATTERN);
        return `${start} bis ${end} Uhr`;
    }
    return "";
}
export function getTimeIntervals(cruise, service) {
    const times = getOpeningTime(cruise, service);
    if (times?.length > 0) {
        const opened = times[0];
        const closed = times[1];
        const list = [];
        let current = opened;
        while (current < closed) {
            list.push(DT.format(current, "HH:mm"));
            current = DT.addMinutes(current, 15);
        }
        return list;
    }
    return null;
}
export function checkDate(input, cruise) {
    const { patterns } = Config.date;
    if (!input || !input.length) {
        return "empty";
    }
    else if (input &&
        (!DT.isValid(input, patterns.de) || input.length < patterns.de.length) &&
        (!DT.isValid(input, patterns.en) || input.length < patterns.en.length)) {
        return "invalid";
    }
    const range = getServiceDates(cruise);
    const inputdate = DT.isValid(input, patterns.en)
        ? DT.parse(input, patterns.en)
        : DT.parse(input, patterns.de);
    if (range &&
        ((range[0] && inputdate < range[0]) || (range[1] && inputdate > range[1]))) {
        return "out-of-range";
    }
    return "";
}
export function checkTime(input, cruise, service, withRounding = false) {
    if (!input.length) {
        return "empty";
    }
    if (!DT.isValid(input, TIMEPATTERN) || input.length < TIMEPATTERN.length) {
        return "invalid";
    }
    const times = getOpeningTime(cruise, service);
    const serviceDuration = service["dienstleistung/dauer-in-minuten"];
    let inputAsDate = DT.parse(input, TIMEPATTERN);
    if (times && serviceDuration && inputAsDate) {
        if (withRounding) {
            inputAsDate = roundDateTimeToNearest5Minutes(inputAsDate);
        }
        if (inputAsDate < times[0] || inputAsDate > times[1]) {
            return "out-of-range";
        }
        if (DT.addMinutes(inputAsDate, serviceDuration) > times[1]) {
            return "service-overlaps-range";
        }
    }
    return "";
}
export function roundDateTimeToNearest5Minutes(date) {
    const coeff = 1000 * 60 * 5;
    return new Date(Math.round(date.getTime() / coeff) * coeff);
}
export function roundTimestring(input) {
    if (!DT.isValid(input, TIMEPATTERN) || input.length < TIMEPATTERN.length) {
        return input;
    }
    const inputAsDate = DT.parse(input, TIMEPATTERN);
    const rounded = roundDateTimeToNearest5Minutes(inputAsDate);
    return DT.format(rounded, TIMEPATTERN);
}
export function mapCurrency(name) {
    switch (name) {
        case "euro":
            return "€";
        default:
            return name;
    }
}
export async function getWebtexte() {
    const categories = [
        "spa__ueberschrift",
        "spa__einleitung",
        "spa__infotext",
        "spa__stornotext",
        "spa__tab_ueberschrift",
        "spa__tab_einleitung",
        "spa__formular_einleitung",
        "spa__nicht_mehr_buchbar",
        "spa__tab_legende",
    ];
    return loadWebtexte(categories, "webtexte.spa-wellness");
}
export async function save(jwt, rechnr, tnnr, serviceid, datestring, timestring) {
    const { patterns } = Config.date;
    const germanDateString = !DT.isValid(datestring, patterns.de)
        ? DT.format(DT.parse(datestring, patterns.en), patterns.de)
        : datestring;
    return callService("meinphoenixservices.termine", {
        "remote-addr": "set by backend",
        type: "terminwunsch-erfassen",
        "id-dienstleistung": serviceid,
        datum: germanDateString,
        uhrzeit: timestring,
        "rech-nr": rechnr,
        "tn-nr": tnnr,
        jwt: jwt,
    });
}
export async function acceptAlternative(jwt, rechnr, resid) {
    return answerAlternative(jwt, rechnr, resid, "terminvorschlag-akzeptieren");
}
export async function declineAlternative(jwt, rechnr, resid) {
    return answerAlternative(jwt, rechnr, resid, "terminvorschlag-ablehnen");
}
export async function answerAlternative(jwt, rechnr, resid, type) {
    return callService("meinphoenixservices.termine", {
        "remote-addr": "set by backend",
        "termin-id": resid,
        "rech-nr": rechnr,
        type: type,
        jwt: jwt,
    });
}
export function isCancelable(booking) {
    return getStartInDays(booking) > 1;
}
export async function cancelBooking(jwt, rechnr, resid) {
    return callService("meinphoenixservices.termin-storno", {
        type: "termin-stornieren",
        "remote-addr": "set by backend",
        "termin-id": resid,
        "rech-nr": rechnr,
        jwt: jwt,
    });
}
export default Model;
